import axios from "../plugins/axios";

async function getAll(payload) {
  const res = await axios.get("/qr-app/table", payload);
  return res.data.data;
}

async function getToken(payload) {
  axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_SERVER;
  const result = await axios.post("/api/v2/oauth/token", {
    grant_type: "password",
    client_id: process.env.VUE_APP_CLIENT_ID,
    client_secret: process.env.VUE_APP_CLIENT_SECRET,
    username: process.env.VUE_APP_EMAIL,
    password: process.env.VUE_APP_PASSWORD,
    scope: "*",
  });
  const data = await result.data;
  axios.defaults.headers.common = {
    Authorization: `Bearer ${data.access_token}`,
    Accept: "application/json",
    Desc: "First token",
  };
  axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_SERVER + process.env.VUE_APP_ROOT_API_PATH;
  return data;
}

const authService = {
  getAll,
  getToken,
};

export default authService;
